import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LoadingService } from 'src/app/services/loading.service';
import { SnackService } from 'src/app/services/snack.service';
import { TourDetailTour } from '../helper/model/tour-detail-tour';
import { Observable } from 'rxjs';
import { _get } from '../../../../../../services/base.service';

@Injectable({
  providedIn: 'root',
})
export class TourDetailServiceControllerRequestService {
  private readonly get: <T>(
    path: string,
    deserialize: (response: any) => T
  ) => Observable<T>;

  private readonly deserialize = (res) => res as TourDetailTour;
  constructor(
    http: HttpClient,
    snackService: SnackService,
    loadingService: LoadingService,
    router: Router
  ) {
    const requestServices = {
      http,
      loadingService,
      router,
      snackService,
    };
    this.get = _get('/tours/tourDetail', requestServices);
  }

  public tourDetail(
    id: number,
    hideRepos: boolean = false
  ): Promise<TourDetailTour> {
    const hideReposParam: string = `hideRepos=${hideRepos}`;
    return this.get(`/${id}?${hideReposParam}`, this.deserialize).toPromise();
  }
}
